exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".store-filter-select{display:flex;align-items:center;justify-content:space-between;width:100%;padding:12px 16px;background:#fff;border:1px solid #697576;border-radius:4px;cursor:pointer;text-align:left;color:#0f1111}", ""]);

// exports
